"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;

var tslib_1 = require("tslib");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var base = "\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 10, 38, 0.6);\n";
var isFullScreen = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: fixed;\n  height: 100vh;\n  height: -webkit-fill-available;\n  width: 100vw;\n  backdrop-filter: blur(0.25rem);\n  z-index: ", ";\n"], ["\n  position: fixed;\n  height: 100vh;\n  height: -webkit-fill-available;\n  width: 100vw;\n  backdrop-filter: blur(0.25rem);\n  z-index: ", ";\n"])), ui_symbols_1.PLANE.OVERLAY);
exports.Root = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), base, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isFullScreen', isFullScreen);
});
var templateObject_1, templateObject_2;